var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('margin-top: 150px; padding: 20px;')},[_c('hr',{staticStyle:{"background-color":"white","margin-bottom":"20px"}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","color":"black"}},[_vm._v("\n     © 2017 - "+_vm._s(new Date().getFullYear())+" Raizzon Infotech LLP\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696ae4b4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer/Index.vue
// module id = 73
// module chunks = 0